// Products flagged in Admin win; when nothing is flagged we fall back to the newest blanks
// so the New Launch showcase is never silently empty on a fresh site.
export const newLaunchItems = (products = []) => {
  const flagged = products.filter((p) => p.is_new_launch);
  if (flagged.length) return { items: flagged, flagged: true };
  const latest = [...products]
    .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))
    .slice(0, 8);
  return { items: latest, flagged: false };
};
